export const CircleDot = ({ fillColor }: { fillColor: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="none"
      role="img"
      aria-label="circle dot"
    >
      <circle cx="3" cy="3" r="3" fill={fillColor} />
    </svg>
  );
};
